import { FC, useState } from "react";

import { EllipsisIcon } from "../../../assets/img/icons";
import Dropdown, { DropdownDirection } from "../../OldDropdown";
import Button from "../../../components/Button";

import styles from "./styles.module.scss";
import { Option } from "../../../types/Option";
import IconButton from "../../IconButton";

type Props = {
    dropdownDirection: DropdownDirection,
    options: Option[]
};

const Options: FC<Props> = ({ options, dropdownDirection }) => {
    const [open, setOpen] = useState(false);

    const handleOptionClick = (option: Option) => {
        setOpen(false);
        option.onClick();
    };

    return (
        <Dropdown
            open={open}
            setOpen={setOpen}
            direction={dropdownDirection}
            trigger={
                <IconButton
                    size="medium"
                    icon={EllipsisIcon}
                    onClick={() => setOpen(!open)}
                />
            }
        >
            <div className={styles.content_container}>
                {options.map((option) => (
                    <Button
                        key={option.label}
                        labelOptions={{ align: "left", noWrap: true }}
                        size="small"
                        variant="transparent"
                        label={option.label}
                        onClick={() => handleOptionClick(option)}
                    />
                ))}
            </div>
        </Dropdown>
    );
};

export default Options;
